module.exports = __webpack_public_path__ + "assets/img/pin.ab564caf.svg";